import React from "react";
import { Link } from "react-router";
import clsx from "clsx";

interface ButtonProps {
    className?: string,
    isSubmit?: boolean,
    children: React.ReactNode,
    onClick?: () => void
    to?: string | null,
    disabled?: boolean,
    size?: "sm"|"md",
}

const Button: React.FC<ButtonProps> = (
    {
        className = null,
        isSubmit = false,
        disabled = false,
        children,
        onClick,
        size = "md",
        to,
    }
) => {
    const classes = clsx(
        "flex justify-center items-center  font-medium tracking-wide text-white capitalize",
        "transition-colors duration-300 transform bg-accent-600 rounded-lg first-letter:capitalize",
        "focus:outline-hidden focus:ring-3 focus:ring-blue-300 focus:ring-blue-300/50",
        "disabled:opacity-50 disabled:cursor-not-allowed", {
            "hover:bg-primary-400": !disabled,
            "px-2 md:px-4 py-2 h-[30px] text-xs": size === "sm",
            "px-4 md:px-8 py-3 h-[50px] text-sm": size === "md",
        },
        className,
    );

    if (to) {
        if (disabled) {
            return (
                <span className={classes}>
                    {children}
                </span>
            );
        }
        return (
            <Link
                className={classes + " hover:no-underline"}
                to={to}
            >
                {children}
            </Link>
        );
    } else {
        return (
            <button
                type={isSubmit ? "submit" : "button"}
                className={classes}
                onClick={onClick}
                disabled={disabled}
            >
                {children}
            </button>
        );
    }

};

export default Button;
//
// interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
//     t?: 'primary' | 'default' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
// }
//
// const Button: React.FC<ButtonProps> = ({ children, variant = 'default', ...props }) => {
//     const styles = {
//         primary: 'bg-blue-500 hover:bg-blue-700 text-white',
//         secondary: 'bg-gray-400 hover:bg-gray-500 text-white',
//         success: 'bg-green-500 hover:bg-green-700 text-white',
//         danger: 'bg-red-500 hover:bg-red-700 text-white',
//         warning: 'bg-yellow-400 hover:bg-yellow-500 text-black',
//         info: 'bg-light-blue-400 hover:bg-light-blue-500 text-white',
//         light: 'bg-gray-200 hover:bg-gray-300 text-black',
//         dark: 'bg-gray-800 hover:bg-gray-900 text-white',
//         default: 'bg-gray-400 hover:bg-gray-500 text-white',
//     };
//
//     const className = `font-bold py-2 px-4 rounded-sm ${styles[variant]}`;
//
//     return (
//         <button className={className} {...props}>
//             {children}
//         </button>
//     );
// };
//
// export default Button;